<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
      <router-link to="/" class="navbar-brand">OneScan</router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto"></ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link to="/hexascii" class="nav-link">Hex Ascii</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/flags" class="nav-link">Flags</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/qrdeeplinks" class="nav-link"
              >QR DeepLinks</router-link
            >
          </li>
          <template v-if="user.loggedIn">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
                >IDP QR Tools</a
              >
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <router-link to="/" class="dropdown-item">QR-IDP</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/qridpsl" class="dropdown-item"
                    >QR-SL</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/qridpgl" class="dropdown-item"
                    >QR-GL</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/qridpstg" class="dropdown-item"
                    >QR-IDP-STG</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/" class="dropdown-item"
                    >QR-IDP-STG-FRN</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/qridpqa" class="dropdown-item"
                    >QR-IDP-QA</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/qridpqa-prev" class="dropdown-item"
                    >QR-IDP-QA-PREV</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/qridpstgtest" class="dropdown-item"
                    >QR-IDP-STG-TEST</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/qridpau" class="dropdown-item"
                    >QR-IDP-AU</router-link
                  >
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
                >DK Tools</a
              >
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <router-link to="/qrdk" class="dropdown-item"
                    >QR-DK</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkkeys" class="dropdown-item"
                    >DK-Keys</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dktransportkeys" class="dropdown-item"
                    >DK-Transport-Keys</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkvehiclestatus" class="dropdown-item"
                    >DK-Vehicle-Status</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkvehiclestatussimple" class="dropdown-item"
                    >DK-Vehicle-Status-Simple</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkdeletekeyinfo" class="dropdown-item"
                    >DK-Delete-Installed</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkresetasset" class="dropdown-item"
                    >DK-Reset-Asset</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkaddvehicle" class="dropdown-item"
                    >DK-Add-Vehicle</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkassetserial" class="dropdown-item"
                    >DK-Asset-To-Serial</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/dkerrors" class="dropdown-item"
                    >DK-Errors</router-link
                  >
                </li>
              </ul>
            </li>

            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
                >Other Tools</a
              >
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <router-link to="/frnativecrypto" class="dropdown-item"
                    >FRNative Crypto</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/frnativetoken" class="dropdown-item"
                    >FRNative Token</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/music" class="dropdown-item"
                    >Link Music Service</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/pinreset" class="dropdown-item"
                    >PIN Reset</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/points" class="dropdown-item"
                    >POI Service</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/lastmile" class="dropdown-item"
                    >Last Mile</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/driver" class="dropdown-item"
                    >Remote Driver</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/sendtocar" class="dropdown-item"
                    >SendToCar</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/sendpush" class="dropdown-item"
                    >Send Push</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/cleanvin" class="dropdown-item"
                    >Clean VIN</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/linkvehicle" class="dropdown-item"
                    >Link Vehicle</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/regvehicle" class="dropdown-item"
                    >Register Vehicle 21MM</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/regvehicletoo" class="dropdown-item"
                    >Register Vehicle Too</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/vehiclematchmaker" class="dropdown-item"
                    >Vehicle Match Maker</router-link
                  >
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <router-link to="/frtmecreate" class="nav-link"
                >TME Create</router-link
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" @click.prevent="signOut">Sign out</a>
            </li>
          </template>
          <template v-else>
            <li class="nav-item">
              <router-link to="/" class="nav-link">Login</router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link to="register" class="nav-link">Register</router-link>
            </li> -->
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from "vuex";
import firebase from "firebase";
export default {
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user",
    }),
  },
  methods: {
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "login",
          });
        });
    },
  },
};
</script>
